export function getServicesMenuItems(siteStatus, wl_link = "/treatment/weight-loss") {
	const price = (priceKey, from = false, extra = "") => {
		const priceAmount = siteStatus?.prs_mc?.[priceKey];
		return priceAmount ? `${from ? "From " : ""}$${priceAmount}${extra}` : null;
	};

	return [
		{
			category: "Select a service:",
			items: [
				{
					title: "Doctor consultation",
					description: "Medical advice on a general health concern.",
					priceKey: "dc_std",
					price: price("dc_std"),
					icon: "doc-steth",
					href: "/gp-online",
					ctaLink: "/m/pharm/DocCons/DocConsCov",
					footerOrder: 2,
					homeOrder: 1,
				},
				{
					title: "Prescriptions",
					description: "If your medication has run out.",
					priceKey: "mc_new",
					price: price("mc_new", true),
					icon: "pill-bottle",
					href: "/online-scripts",
					ctaLink: "/m/pharm/online/prescription",
					footerOrder: 1,
					homeOrder: 2,
				},
				{
					title: "Medical certificates",
					description: "When you require a medical certificate.",
					priceKey: "mc_std",
					price: price("mc_std", true),
					icon: "med-cert",
					href: "/online-medical-certificates",
					ctaLink: "/c/pharm/certs",
					footerOrder: 5,
					homeOrder: 3,
				},
				{
					title: "Pathology referrals",
					description: "Pathology referrals for a range of conditions.",
					priceKey: "mc_pt_pr",
					price: price("mc_pt_pr"),
					icon: "patho-blood-drop",
					href: "/online-pathology-requests",
					ctaLink: "/c/pharm/patho",
					footerOrder: 3,
					homeOrder: 4,
				},
				{
					title: "Specialist referrals",
					description: "Skin, eye and colonoscopy specialist referrals.",
					priceKey: "mc_pt_pr",
					price: price("mc_pt_pr"),
					icon: "eye",
					href: "/online-specialist-referrals",
					ctaLink: "/c/pharm/express-specialist-referrals",
					footerOrder: 4,
					homeOrder: 5,
				},
			],
		},
		{
			category: "Other services:",
			items: [
				{
					title: "Urinary tract infections",
					abbr: "UTIs",
					description: "If you believe you have a urinary tract infection.",
					priceKey: "dc_uti_pr",
					price: price("dc_uti_pr"),
					icon: "female-waist",
					href: "/treatment/urinary-tract-infection",
					homeOrder: 9,
				},
				{
					title: "Weight management",
					description: "Treatment options to manage weight.",
					priceKey: "dc_wlinj_pr",
					price: price("dc_wlinj_pr"),
					icon: "diet-scales",
					href: wl_link,
					footerOrder: 7,
					homeOrder: 6,
				},
				{
					title: "Mental health",
					description: "For treatment of anxiety, depression and more.",
					priceKey: "mhcp_co_pr",
					price: price("mhcp_co_pr", false, "*"),
					icon: "head-cross",
					href: "/treatment/mental-health",
					footerOrder: 8,
					homeOrder: 7,
				},
				{
					title: "Menopause",
					description: "Menopause and perimenopause symptom management.",
					priceKey: "dc_wlinj_pr",
					price: price("dc_wlinj_pr"),
					icon: "gender-female",
					href: "/treatment/menopause",
					footerOrder: 9,
					homeOrder: 8,
				},
				{
					title: "Skin conditions",
					description: "Treatment of eczema, rosacea, psoriasis and more.",
					priceKey: "dc_sti",
					price: price("dc_sti"),
					icon: "profile-circle",
					href: "/treatment/skincare",
				},
				{
					title: "Skincare",
					description: "Treatment of acne, fine lines, wrinkles and sun damage.",
					priceKey: "dc_sti",
					price: price("dc_sti"),
					icon: "jar-cream-drop",
					href: "/treatment/skincare",
					homeOrder: 10,
					footerOrder: 10,
				},
				{
					title: "Psychologist consultation",
					description: "A video consultation with a psychologist from My Mirror.",
					priceKey: "mhcp_mymi_pr",
					price: price("mhcp_mymi_pr"),
					icon: "multiple-ppl-2",
					href: "https://www.mymirror.com.au/get-matched/?rf=instant-scripts",
				},
				{
					title: "Male Fertility",
					description: "Fertility advice for males and specialist referrals to Adora Fertility.",
					priceKey: "dc_fert",
					price: price("dc_fert"),
					icon: "sperm",
					href: "/treatment/male-fertility",
				},
				{
					title: "Female Fertility",
					description: "Fertility advice for females and specialist referrals to Adora Fertility.",
					priceKey: "dc_fert",
					price: price("dc_fert"),
					icon: "sperm-egg",
					href: "/treatment/female-fertility",
				},
				{
					title: "Quit nicotine",
					description: "If you'd like help quitting nicotine.",
					priceKey: "dc_ssc",
					price: price("dc_ssc"),
					icon: "no-smoking",
					href: "/treatment/quit-smoking-vaping",
					footerOrder: 11,
				},
				{
					title: "Contraception",
					description: "Speak to a doctor for a script or new contraceptive treatment.",
					priceKey: "mc_new",
					price: price("mc_new", true),
					icon: "gender-female",
					href: "/treatment/contraception",
					footerOrder: 13,
				},
			],
		},
	];
}
